import { Drawer } from 'components/Drawer'
import Styles from './TextStylesDrawer.module.scss'
import { TextStylesDrawerProps } from './Types'
import { Heading } from 'blaze-ui/Heading/Heading'
import { BrandKitTextStyles } from './BrandKitTextStyles'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { PresetTextStyles } from './PresetTextStyles'

const TextStylesDrawer = observer(({ onSelect, ...props }: TextStylesDrawerProps) => {
  const { designStore } = useRootStore()
  const brandVisualKitId = designStore?.brandVisualKitId

  return (
    <Drawer.Root {...props} activeSnapPoint={1} snapPoints={[1]}>
      <Drawer.Portal>
        <Drawer.Overlay />
        <Drawer.Content fullHeight>
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Top>
              <Drawer.Close />
              <Drawer.Title asChild>
                <Heading level={5}>Text Styles</Heading>
              </Drawer.Title>
            </Drawer.Top>

            <Drawer.Container>
              <div className={Styles.sections}>
                {brandVisualKitId && <BrandKitTextStyles brandVisualKitId={brandVisualKitId} onSelect={onSelect} />}
                <PresetTextStyles onSelect={onSelect} />
              </div>
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})

export { TextStylesDrawer }
